import React from 'react';
import { get } from 'lodash';
import './CommOptionsCheckbox.scss';

const CommOptionsCheckbox = ({
  input,
  label,
  labelSize,
  smFieldSize,
  smOffset,
  infoButton,
  options,
  objectKey,
  inline,
  width,
}) => {
  return (
    <div className={'comm-options-checkbox-container'}>
      <div className={'comm-options-checkbox-item'}>{label}</div>
      <div className={'comm-options-checkbox-item'}>
        {options.map((option, key) => {
          const value = objectKey ? get(option.value, objectKey) : option.value;
          return (
            <div
              className={'radio-container' + (inline ? ' inline' : '')}
              key={key}
              style={width ? { width: width } : {}}
            >
              <div className={'comm-options-checkbox'}>
                <input
                  {...input}
                  type="checkbox"
                  id={input.name + option.label}
                  value={option.value}
                  checked={input.value.toString() === value.toString()}
                />
                <label htmlFor={input.name + option.label} />
              </div>
              <div className="radio-label" onClick={() => input.onChange(option.value)} />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CommOptionsCheckbox;
